import { render } from "./SaveReportingMethod.vue?vue&type=template&id=d97599de"
import script from "./SaveReportingMethod.vue?vue&type=script&lang=js"
export * from "./SaveReportingMethod.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__